export default {
    methods: {
        reviewCount(offerDetails) {
            return offerDetails && offerDetails.lender && offerDetails.lender.review ? offerDetails.lender.review.total : 0;
        },
    },
};
